export const iconFontAwesomePhotosImagesIdCard = (
	<i className="fa-solid fa-id-card"></i>
);
